/** Contact details and outbound links used across the site. */
export const CONTACT = {
  email: 'ayamosaad224@gmail.com',
  phone: '79073585',
  phoneIntl: '96879073585',
  location: 'سلطنة عُمان',
  author: 'إعداد أستاذة آية سعود',
} as const;

const WHATSAPP_GREETING = 'السلام عليكم ورحمة الله وبركاته - أحتاج إلى المساعدة';

export const WHATSAPP_URL = `https://wa.me/${CONTACT.phoneIntl}?text=${encodeURIComponent(
  WHATSAPP_GREETING,
)}`;

export const MAILTO_URL = `mailto:${CONTACT.email}`;
